/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { Input, Typography } from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../utility/errorCodes";

const COMPONENT_NAME = "Admin components/CSVUploading/FileUploader";

/**
 * Will display the file input html object and parse the file to string.
 * It will then use the callback methods to pass back both the string representation of the file as well as the name of the file.
 */
export const FileUploader = (props) => {
	const [drag, setDrag] = React.useState(false);
	const onUpload = (file) => {
		try {
			props.setFileName(file.name);
			const reader = new FileReader();
			reader.readAsText(file);
			reader.onloadend = () => {
				props.setFile(reader.result && reader.result.toString(), file.name);
			};
		} catch (error) {
			v2.error(`Error uploading web chat CSV file`, {
				additionalData: { error: errorToObject(error) },
				componentName: COMPONENT_NAME,
				logCode: errorCodes.UPLOAD_CSV_ERROR,
			});
		}
	};

	const handleFileSelect = (event) => {
		onUpload(event.target.files[0]);
	};

	const onDragOver = (isOver) => (e) => {
		e.preventDefault();
		e.stopPropagation();
		setDrag(isOver);
	};

	// Handle file drop
	const onDrop = (e) => {
		e.stopPropagation();
		e.preventDefault();
		const files = e.dataTransfer.files;
		if (files && files.length > 0) {
			onUpload(files[0]);
		}
		setDrag(false);
	};
	return (
		<div style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}>
			<Input id="upload-file-button" hidden type={"file"} name={"file"} onChange={handleFileSelect}></Input>
			<label htmlFor="upload-file-button" style={{ width: props.width || "300px" }}>
				<div
					id="dropContainer"
					style={{
						border: "2px dashed gray",
						borderRadius: 5,
						backgroundColor: drag ? "gray" : "whitesmoke",
						minHeight: props.minHeight || "100px",
						width: props.width || "300px",
						cursor: "pointer",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						flexDirection: "column",
					}}
					onDrop={onDrop}
					onDragOver={onDragOver(true)}
					onDragEnter={onDragOver(true)}
					onDragLeave={onDragOver(false)}
					onMouseEnter={() => setDrag(true)}
					onMouseLeave={() => setDrag(false)}
				>
					{props.fileName ? (
						<FileCopyIcon style={{ width: "100%" }} fontSize={"large"}></FileCopyIcon>
					) : (
						<AttachFileIcon style={{ width: "100%" }} fontSize={"large"}></AttachFileIcon>
					)}
					<Typography style={{ overflow: "hidden", width: "100%", textAlign: "center" }} title={props.fileName}>
						{props.fileName}
					</Typography>
				</div>
			</label>
		</div>
	);
};
